import React from 'react';

// A detail-card section listing graph-related entities as chips, with a single
// PROVENANCE line (source + confidence) — provenance is a security property
// (SAD §8.1). Driven purely by selector output, never a field on an entity.

const CONF_CLASS = { authoritative: 'auth', community: 'comm', unverified: 'unver' };
const CONF_LABEL = { authoritative: 'Authoritative', community: 'Community', unverified: 'Unverified' };

const MappedEntities = ({ title, items, chipClass = '', emptyHint }) => {
  // Provenance is uniform per dataset; summarise from the first item, flag mixes.
  const sources = Array.from(new Set(items.map((i) => i.source).filter(Boolean)));
  const confidence = items[0]?.confidence;

  return (
    <div className="tv-sec">
      <div className="tv-st">
        {title}
        <span style={{ color: 'var(--tv-muted)', textTransform: 'none', letterSpacing: 0 }}>
          ({items.length})
        </span>
      </div>

      {items.length === 0 ? (
        <span className="tv-empty">{emptyHint}</span>
      ) : (
        <>
          <div className="tv-chips">
            {items.map(({ id, name }) => (
              <span key={id} className={`tv-chip ${chipClass}`}>
                {id}
                {name ? ` ${name}` : ''}
              </span>
            ))}
          </div>
          {sources.length > 0 && (
            <div className="tv-prov">
              <b>{sources.length === 1 ? sources[0] : `${sources.length} sources`}</b>
              {confidence && (
                <span className={`tv-conf ${CONF_CLASS[confidence] || ''}`}>
                  {CONF_LABEL[confidence] || confidence}
                </span>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default MappedEntities;
